<template>
    <div class="search">
        <div class="car-image-wrapper" v-if="image" @click="image = null">
            <img :src="image" />
        </div>
        <div class="floating-top-banner-mobile animated fadeInDown delay-1s" @click="goToInsurancePartner('Samlino (mobile banner)')">
            <img src="/static/partners/samlino-mobile-banner2.jpg" />
        </div>
        <top-menu />
        <div class="main-content">
            <div class="container" style="position:relative;">
                <div class="floating-partner animated fadeInLeft delay-5s floating-partner__left" @click="goToInsurancePartner('Samlino (banner)')" v-if="!$store.state.searching && $store.state.match">
                    <div class="inner">
                        <img src="/static/partners/samlino-high-banner.jpg" />
                    </div>
                </div>
                <div class="floating-partner animated fadeInRight delay-5s floating-partner__right" @click="goToBroadbandPartner('Fastspeed (banner)')" v-if="!$store.state.searching && $store.state.match">
                    <div class="inner">
                        <img src="/static/partners/fastspeed_high_2.png" />
                    </div>
                </div>
                <!--<div class="floating-partner animated fadeInRight delay-5s floating-partner__right" @click="goToBilmagasinet('banner')" v-if="!$store.state.isLoading && $store.state.vehicleData !== null">
                    <div class="inner">
                        <img src="/static/partners/bilmagasinet-high-banner.jpeg" />
                    </div>
                </div>-->
                <!--<div class="campaign-wrapper campaign-wrapper__left">
                    <div class="inner">
                        <img src="/static/auto.png" />
                    </div>
                </div>
                <div class="campaign-wrapper campaign-wrapper__right">
                    <img src="/static/auto.png" />
                </div>-->
                <router-view class="animated fadeIn" v-if="$store.state.match"></router-view>
                <div class="no-results" v-if="!$store.state.searching && !$store.state.match">
                    Vi fandt desværre ingen resultater på din søgning.
                    <br><br>
                    Tjek venligst, at du har indtastet de korrekte oplysninger og prøv igen.
                    <br><br>
                    Har du indtastet den korrekte nummerplade, er det muligt, at et af registrene ikke svarer.
                    <br>
                    Vi beder dig derfor prøve igen senere og beklager ulejligheden.
                </div>
                <div class="loader-spinner" v-if="$store.state.searching">
                    <!--<i class="fa fa-spinner fa-spin" />-->
                    <div class="loader-wrapper" v-if="$store.state.searching">
                        <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <foo />
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars";

    @media screen and (min-width: 1200px) {
        .container {
            // width: 970px;
        }
    }

    .floating-top-banner-mobile {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
        z-index: 999;

        img {
            width: 100%;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
        }

        @media screen and (max-width: $small) {
            display: block;
        }
    }

    .search {

        @media screen and (max-width: $small) {
            // padding-top: calc((100vw / 930) * 180);
            padding-top: calc((100vw / 728) * 90);
        }
    }

    .car-image-wrapper {
        display: none;
    }

    @media screen and (min-width: $large) {
        .car-image-wrapper {
            display: block;
            position: fixed;
            bottom: 30px;
            right: 30px;
            background: #fff;
            z-index: 99;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);

            img {
                width: 100%;
                max-width: 300px;
                max-height: 200px;
                object-fit: cover;
                border-radius: 5px;
            }
        }
    }

    .floating-partner {
        display: none;
        position: absolute;
        height: calc(100% - 30px);
        width: 140px;
        border-radius: 5px;
        transition: 0.3s ease all;

        @media screen and (min-width: 1550px) {
            display: block;
        }

        @media screen and (min-width: 1400px) and (max-width: 1549px) {
            display: block;
            width: 100px;

            .inner {
                top: calc(50% - 187px) !important;
            }

            &__left {
                left: -110px !important;
            }

            &__right {
                right: -110px !important;
            }
        }

        .inner {
            position: sticky;
            top: calc(50% - 262px);
        }

        img {
            width: 100%;
            border-radius: 5px;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
            cursor: pointer;
            transition: 0.3s ease all;

            &:hover {
                transform: translateY(-4px);
            }
        }

        &__left {
            left: -160px;
        }

        &__right {
            right: -160px;
        }
    }

    .container {
        position: relative;
    }

    .no-results {
        color: #fff;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        padding: 50px 0;
    }

    .campaign-wrapper {
        position: absolute;
        top: 0px;

        &__left {
            left: -195px;
        }

        &__right {
            right: -195px;
        }

        img {
            width: 150px;
        }
    }

    .search {
        background: $color--main;
        // background: linear-gradient(to bottom, $color--main, darken($color--main, 10%));
        min-height: 100vh;
    }

    .loader-spinner {
        font-size: 50px;
        text-align: center;
        color: #fff;
    }

    .main-content {
        // min-height: calc(100vh - 240px);
        background: linear-gradient(to bottom, $color--main, darken($color--main, 10%));
    }

</style>

<style lang="scss">
@import "../../../styles/vars";

    @media screen and (max-width: $small) {
        [id^=_hj-] {
            display: none !important;
        }
    }

    @media screen and (max-width: $medium) {
        .content-layout {

            .column:not(.single-partner) {
                flex: 0 0 100% !important;
                max-width: 100% !important;
            }

            .column.single-partner {
                flex: 0 0 calc(50% - 15px) !important;
                max-width: calc(50% - 15px) !important;

                &:nth-of-type(1),
                &:nth-of-type(2) {
                    margin-bottom: 30px;
                }
            }
        }
    }

    .content-layout {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .column {

            &__large {
                flex: 0 0 calc(70% - 15px);
                max-width: calc(70% - 15px);
            }

            &__medium {
                flex: 0 0 calc(50% - 15px);
                max-width: calc(50% - 15px);
            }

            &__third {
                flex: 0 0 calc(35% - 22.5px);
                max-width: calc(35% - 22.5px);
            }

            &__small {
                flex: 0 0 calc(30% - 15px);
                max-width: calc(30% - 15px);
            }

            &__xs {
                flex: 0 0 calc(25% - 15px);
                max-width: calc(25% - 15px);
            }
        }
    }

    .block {
        background: #fff;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        padding: 30px;
        margin-bottom: 30px;
        box-sizing: border-box;
        width: 100%;

        .title {
            font-size: 24px;
            margin-bottom: 15px;
            font-weight: bold;
        }

        .body {
            overflow: hidden;
            padding-top: 5px;

            &.narrow {
                
                .line__title {
                    flex: 0 0 30%;
                }

                .line__value {
                    flex: 0 0 70%;
                }
            }

            &.align-top {

                .line {
                    align-items: flex-start;
                }
            }

            .meta {
                display: flex;
                justify-content: space-between;
            }

            .line {
                display: flex;
                // align-items: center;

                @media screen and (max-width: $small) {
                    // display: block;
                    justify-content: space-between;

                    &.wide {
                        display: flex !important;
                        text-align: left !important;
                    }

                    &.align-center {
                        
                        .line__title {
                            flex: 0 0 50% !important;
                            flex-grow: 0 !important;
                            white-space: normal !important;
                        }

                        .line__value {
                            flex: 0 0 50% !important;
                            flex-grow: 0 !important;
                        }
                    }

                    &__title {
                        flex-grow: 1 !important;
                        // white-space: nowrap;
                        flex: 0 0 auto !important;
                        max-width: 100%;
                    }

                    &__value {
                        flex-grow: 1 !important;
                        flex: 0 0 auto !important;
                        // white-space: nowrap;
                        // text-align: right;
                        max-width: 100%;
                    }
                }

                .extra {
                    font-weight: 400;
                }

                &:not(:last-of-type) {
                    margin-bottom: 15px;
                }

                &__title {
                    flex: 0 0 50%;
                    font-weight: 400;
                    word-break: break-word;
                    padding-right: 15px;
                }

                &__value {
                    flex: 0 0 50%;
                    font-weight: 600;
                    word-break: break-word;

                    a {
                        color: $color--main;
                    }
                }

                &.wide {
                    display: block;
                    text-align: center;
                }
            }
        }
    }

</style>


<script>
import TopMenu from './components/topmenu'
import Foo from './components/footer'
import * as vehicleService from '@/services/vehicle/vehicleService'
// import * as imageService from '@/services/image/imageService'
import axios from 'axios'
import * as Sentry from '@sentry/browser'

import * as apiLookupService from '@/services/api/lookup/lookupService'

export default {
    data () {
        return {
            image: null
        }
    },
    components: {
        TopMenu,
        Foo
    },
    created () {
        this.checkForQuery()
    },
    methods: {
        /* searchCarImage () {
            let brand = encodeURI(this.$store.state.vehicleData.general.MaerkeTypeNavn)
            let model = encodeURI(this.$store.state.vehicleData.general.ModelTypeNavn)
            // let year = moment(this.$store.state.vehicleData.general.FoersteRegistreringDato).format('YYYY')
            let searchString = brand + '+' + model
            imageService.find(searchString, {}, (response) => {
                // console.log(response.data)
                let formattedString = response.data.substr(79)
                let formattedStringSecond = formattedString.substr(0, formattedString.length - 9)
                this.image = formattedStringSecond
            })
        }, */
        checkForQuery () {
            if (this.$route.params.licenseplate !== null) {
                // this.doSearch(this.$route.params.licenseplate)
                this.getCarDetails(this.$route.params.licenseplate)
            }
        },
        getCarDetails (licenseplate, redirectToOverview) {
            this.$store.state.carData.general = null
            this.$store.state.carData.dmr = null
            this.$store.state.carData.registry = null
            this.$store.state.carData.inspection = null
            this.$store.state.carData.lookups = null
            this.$store.state.searching = true
            let params = {
                'licenseplate': licenseplate
            }
            apiLookupService.plate(params, (response) => {
                let inputtedLicenseplate = licenseplate.split(' ').join('').toUpperCase()
                if (response.data.RegNr !== inputtedLicenseplate) {
                    window.location.href = '/soeg/' + response.data.RegNr + '/overblik'
                    return
                }
                this.$store.state.carData.general = response.data

                let carId = response.data.KoeretoejId
                let carVin = response.data.StelNr
                let carPlate = response.data.RegNr

                if (carPlate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && carPlate.length === 7) {
                    let splittedString = licenseplate.split('')
                    splittedString.splice(2, 0, ' ')
                    splittedString.splice(5, 0, ' ')
                    splittedString = splittedString.join('')
                    this.$store.state.licenseplate = splittedString.toUpperCase()
                } else {
                    this.$store.state.licenseplate = licenseplate.toUpperCase()
                }

                this.getWantedDetails(carPlate)
                this.getDmrDetails(carId)
                this.getRegistryDetails(carVin, carPlate)
                this.getInspectionDetails(carVin, carId)
                this.getLookups(carId)
                this.postLookup(carId, carPlate)

                this.$store.state.searching = false
                this.$store.state.match = true
                this.$store.state.showingResult = true
                if (process.env.NODE_ENV === 'production') {
                    let carString = this.$store.state.carData.general.RegNr.toUpperCase() + ' | ' + this.$store.state.carData.general.MaerkeTypeNavn + ' ' + this.$store.state.carData.general.ModelTypeNavn + ' ' + this.$store.state.carData.general.VariantTypeNavn
                    if ('ga' in window) {
                        let tracker = window.ga.getAll()[0]
                        if (tracker) {
                            tracker.send('event', 'Søgeresultat', 'Nummerplade', carString)
                            /* if (this.$store.state.carData.dmr.Forsikring.Selskab === 'SELVFORSIKRING') {
                                tracker.send('event', 'Civile politibiler', 'Nummerplade', carString)
                            }
                            if (this.$store.state.carData.wanted !== null && this.$store.state.carData.wanted.PoliceWantedStatus === 0) {
                                tracker.send('event', 'Efterlyst køretøj', 'Nummerplade', carString)
                            } */
                        }
                    }
                    /* if (this.$store.state.carData.general.KoeretoejArtNavn === 'Motorcykel') {
                        formattedText = ':racing_motorcycle: *' + this.$store.state.carData.general.RegNr + '* - ' + vehicleResult
                    } else {
                        formattedText = ':car: *' + this.$store.state.carData.general.RegNr + '* - ' + vehicleResult
                    }
                    if (this.$store.state.carData.general.RegNr.toUpperCase() !== 'AL52114') {
                        axios.post('https://hooks.slack.com/services/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', {
                            username: 'NrPladeTjek.dk',
                            icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                            text: formattedText
                            },
                            {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        })
                    } */
                }
                let hrefString = window.location.pathname
                let slashCount = hrefString.match(/\//g).length
                if (slashCount === 2) {
                    this.$router.push({name: 'SearchOverview'})
                }
                if (redirectToOverview) {
                    this.$router.push({name: 'SearchOverview'})
                }
            }, (err) => {
                console.log(err)
                this.$store.state.searching = false
                this.$store.state.match = false
                this.$store.state.showingResult = true
                this.$store.state.isLoading = false
                if (licenseplate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    let splittedString = licenseplate.split('')
                    splittedString.splice(2, 0, ' ')
                    splittedString.splice(5, 0, ' ')
                    splittedString = splittedString.join('')
                    this.$store.state.licenseplate = splittedString.toUpperCase()
                } else {
                    this.$store.state.licenseplate = licenseplate.toUpperCase()
                }
                Sentry.captureException(new Error('API error 2'))
                Sentry.withScope(scope => {
                    scope.setExtra('state', this.$store.state)
                    scope.setExtra('data', err)
                    Sentry.captureException(new Error('New API error'))
                    if ('ga' in window) {
                        let tracker = window.ga.getAll()[0]
                        if (tracker) {
                            tracker.send('event', 'Fejl', 'New API error', this.$store.state.licenceplate)
                        }
                    }
                })
            })
        },
        getWantedDetails (licenseplate) {
            this.$store.state.loadingWanted = true
            let params = {
                'licenseplate': licenseplate
            }
            apiLookupService.wanted(params, (response) => {
                this.$store.state.carData.wanted = response.data
                this.$store.state.loadingWanted = false
            }, (err) => {
                console.log(err)
                this.$store.state.loadingWanted = false
            })
        },
        getDmrDetails (vehicleUuid) {
            this.$store.state.loadingDmr = true
            let params = {
                'vehicle_uuid': vehicleUuid
            }
            apiLookupService.dmr(params, (response) => {
                this.$store.state.carData.dmr = response.data
                this.$store.state.loadingDmr = false
            }, (err) => {
                this.$store.state.match = false
                console.log(err)
                this.$store.state.loadingDmr = false
            })
        },
        getRegistryDetails (vinNumber, licenseplate) {
            this.$store.state.loadingRegistry = true
            let params = {
                'vin_number': vinNumber,
                'licenseplate': licenseplate
            }
            apiLookupService.registry(params, (response) => {
                this.$store.state.carData.registry = response.data
                this.$store.state.loadingRegistry = false
            }, (err) => {
                console.log(err)
                this.$store.state.loadingRegistry = false
                this.$store.state.match = false
            })
        },
        getInspectionDetails (vinNumber, vehicleUuid) {
            this.$store.state.loadingInspection = true
            let params = {
                'vin_number': vinNumber,
                'vehicle_uuid': vehicleUuid
            }
            apiLookupService.inspection(params, (response) => {
                this.$store.state.carData.inspection = response.data
                this.$store.state.loadingInspection = false
            }, (err) => {
                console.log(err)
                this.$store.state.loadingInspection = false
                this.$store.state.match = false
            })
        },
        getLookups (vehicleUuid) {
            this.$store.state.loadingLookups = true
            let params = {
                'vehicle_uuid': vehicleUuid
            }
            apiLookupService.countVehicle(params, (response) => {
                this.$store.state.carData.lookups = response.data
                this.$store.state.loadingLookups = false
            }, (err) => {
                console.log(err)
                this.$store.state.loadingLookups = false
            })
        },
        postLookup (vehicleUuid, licenseplate) {
            let body = {
                'vehicle_uuid': vehicleUuid,
                'licenseplate': licenseplate
            }
            apiLookupService.postLookup(body, {}, (respone) => {
            }, (err) => {
                console.log(err)
            })
        },
        doSearch (licenseplate, redirectToOverview) {
            this.$store.state.vehicleData = null
            this.$store.state.isLoading = true
            let inputtedLicenseplate = licenseplate.split(' ').join('').toUpperCase()
            vehicleService.find(licenseplate, {}, (response) => {
                this.$store.state.vehicleData = response.data

                if (response.data.general.RegNr !== inputtedLicenseplate) {
                    window.location.href = '/soeg/' + response.data.general.RegNr + '/overblik'
                    return
                }

                let licenseplate = this.$store.state.vehicleData.general.RegNr

                if (licenseplate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    let splittedString = licenseplate.split('')
                    splittedString.splice(2, 0, ' ')
                    splittedString.splice(5, 0, ' ')
                    splittedString = splittedString.join('')
                    this.$store.state.licenseplate = splittedString.toUpperCase()
                } else {
                    this.$store.state.licenseplate = licenseplate.toUpperCase()
                }

                this.$store.state.isLoading = false
                // let vehicleResult = this.$store.state.vehicleData.general.MaerkeTypeNavn + ' ' + this.$store.state.vehicleData.general.ModelTypeNavn + ' ' + this.$store.state.vehicleData.general.VariantTypeNavn
                // let formattedText = ''
                if (process.env.NODE_ENV === 'production') {
                    let carString = this.$store.state.vehicleData.general.RegNr.toUpperCase() + ' | ' + this.$store.state.vehicleData.general.MaerkeTypeNavn + ' ' + this.$store.state.vehicleData.general.ModelTypeNavn + ' ' + this.$store.state.vehicleData.general.VariantTypeNavn
                    if ('ga' in window) {
                        let tracker = window.ga.getAll()[0]
                        if (tracker) {
                            tracker.send('event', 'Søgeresultat', 'Nummerplade', carString)
                            if (this.$store.state.vehicleData.dmr.Forsikring.Selskab === 'SELVFORSIKRING') {
                                tracker.send('event', 'Civile politibiler', 'Nummerplade', carString)
                            }
                            if (this.$store.state.vehicleData.wanted !== null && this.$store.state.vehicleData.wanted.PoliceWantedStatus === 0) {
                                tracker.send('event', 'Efterlyst køretøj', 'Nummerplade', carString)
                            }
                        }
                    }
                    /* if (this.$store.state.vehicleData.general.KoeretoejArtNavn === 'Motorcykel') {
                        formattedText = ':racing_motorcycle: *' + this.$store.state.vehicleData.general.RegNr + '* - ' + vehicleResult
                    } else {
                        formattedText = ':car: *' + this.$store.state.vehicleData.general.RegNr + '* - ' + vehicleResult
                    }
                    if (this.$store.state.vehicleData.general.RegNr.toUpperCase() !== 'AL52114') {
                        axios.post('https://hooks.slack.com/services/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', {
                            username: 'NrPladeTjek.dk',
                            icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                            text: formattedText
                            },
                            {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        })
                    } */
                }
                let hrefString = window.location.pathname
                let slashCount = hrefString.match(/\//g).length
                if (slashCount === 2) {
                    this.$router.push({name: 'SearchOverview'})
                }
                if (redirectToOverview) {
                    this.$router.push({name: 'SearchOverview'})
                }
                if (process.env.NODE_ENV === 'development') {
                    this.searchCarImage()
                }
            }, (err) => {
                this.$store.state.isLoading = false
                if (licenseplate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    let splittedString = licenseplate.split('')
                    splittedString.splice(2, 0, ' ')
                    splittedString.splice(5, 0, ' ')
                    splittedString = splittedString.join('')
                    this.$store.state.licenseplate = splittedString.toUpperCase()
                } else {
                    this.$store.state.licenseplate = licenseplate.toUpperCase()
                }
                Sentry.captureException(new Error('API error 2'))
                Sentry.withScope(scope => {
                    scope.setExtra('state', this.$store.state)
                    scope.setExtra('data', err)
                    Sentry.captureException(new Error('New API error'))
                    if ('ga' in window) {
                        let tracker = window.ga.getAll()[0]
                        if (tracker) {
                            tracker.send('event', 'Fejl', 'New API error', this.$store.state.licenceplate)
                        }
                    }
                })
            })
        },
        goToInsurancePartner (name) {
            let numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            // let link = 'https://ad.doubleclick.net/ddm/trackclk/N861970.2126501SAMLINO.DK/B22969279.250543226;dc_trk_aid=446948115;dc_trk_cid=118543082?https://www.samlino.dk/bilforsikring/indhentpriser?knowLicensePlateNum=true&licensePlateNumUq=' + numberplate + '&utm_source=nrpladetjek&utm_medium=cpc&utm_campaign=ciweek28_19'
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino&media_id=83530'
            if (process.env.NODE_ENV === 'production') {
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Samlino')
                    }
                }
                let formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToBroadbandPartner (name) {
            let numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9581&productGroup=Fastspeed&media_id=83530'
            if (process.env.NODE_ENV === 'production') {
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Fastspeed')
                    }
                }
                let formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToCasinoPartner (name) {
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7474&productGroup=leovegas'
            if (process.env.NODE_ENV === 'production') {
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Leo Vegas')
                    }
                }
                let formattedText = ':male-detective: Affiliate klik på *' + name + '*'
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToBilmagasinet (type) {
            /* let licenseplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            let link = 'https://www.samlino.dk/bilforsikring/indhentpriser?knowLicensePlateNum=true&licensePlateNumUq=' + licenseplate + '&utm_source=nrpladetjek.dk&utm_medium=cpc' */
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9340&productGroup=bonnier'
            if (process.env.NODE_ENV === 'production') {
                let formattedText = ':male-detective: Affiliate klik på *' + 'Bil Magasinet (' + type + ')*'
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', 'Bil Magasinet (banner)')
                    }
                }
            }
            window.open(link, '_blank')
        }
    }
}
</script>




// WEBPACK FOOTER //
// index.vue?d78845b6